//index.js
import TableCell from './TableCell';
import TableRow from './TableRow';

export { TableRow, TableCell };
